"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Notification = _interopRequireDefault(require("./Notification"));
var _styles = require("./styles");
var _Info = _interopRequireDefault(require("../Icons/Status/Info"));
var _Warning = _interopRequireDefault(require("../Icons/Status/Warning"));
var _Error = _interopRequireDefault(require("../Icons/Status/Error"));
var _Danger = _interopRequireDefault(require("../Icons/Status/Danger"));
var _Neutral = _interopRequireDefault(require("../Icons/Status/Neutral"));
var _Success = _interopRequireDefault(require("../Icons/Status/Success"));
var _constants = require("./constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getDefaultIcon = category => {
  switch (category) {
    case _constants.TOAST_CATEGORIES.INFO:
      return _Info.default;
    case _constants.TOAST_CATEGORIES.WARN:
      return _Warning.default;
    case _constants.TOAST_CATEGORIES.ERROR:
      return _Error.default;
    case _constants.TOAST_CATEGORIES.DANGER:
      return _Danger.default;
    case _constants.TOAST_CATEGORIES.NEUTRAL:
      return _Neutral.default;
    case _constants.TOAST_CATEGORIES.SUCCESS:
      return _Success.default;
    default:
      return null;
  }
};
const Toast = (0, _react.memo)(({
  className,
  notification,
  actionHandler,
  hideHandler = () => {},
  readHandler,
  icon
}) => {
  const Icon = icon ?? getDefaultIcon(notification.category);
  return _react.default.createElement(_styles.Toast, {
    className: className,
    "data-test-id": notification === null || notification === void 0 ? void 0 : notification.id
  }, notification && _react.default.createElement(_Notification.default, {
    key: notification.id,
    notification: notification,
    actionHandler: actionHandler,
    onHide: hideHandler,
    onRead: readHandler,
    Icon: Icon
  }));
});
var _default = exports.default = Toast;